import React from "react";
import { useObserver } from "mobx-react-lite";
import { NavLink, useLocation } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  drawer: {
    height: "100%",
    "& a:any-link": {
      color: theme.palette.text.secondary,
      textDecoration: "none",
    },
  },
  drawerPaper: {
    position: "unset",
    minHeight: "100vh",
    maxWidth: "70vw",
  },
  active: {
    color: theme.palette.primary.main,
  },
}));

type Props = {
  menus: {
    to: string;
    label: string;
    icon: React.ReactElement;
  }[];
  DrawerProps: React.ComponentProps<typeof Drawer>;
};

export default ({ menus, DrawerProps }: Props) => {
  const location = useLocation();
  const styles = useStyles();

  return useObserver(() => (
    <Drawer
      className={styles.drawer}
      classes={{ paper: styles.drawerPaper }}
      {...DrawerProps}
    >
      <List>
        {menus.map((menu) => (
          <NavLink key={menu.to} to={menu.to}>
            <ListItem button>
              <ListItemIcon
                className={
                  location.pathname === menu.to ? styles.active : undefined
                }
              >
                {menu.icon}
              </ListItemIcon>
              <ListItemText
                className={
                  location.pathname === menu.to ? styles.active : undefined
                }
                disableTypography
              >
                {menu.label}
              </ListItemText>
            </ListItem>
          </NavLink>
        ))}
      </List>
    </Drawer>
  ));
};
